import { Menu, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function AccessMenuButton(props) {
    const { children } = props;
    return (<Menu.Root target={<IconButton $round appearance="ghost" size="small">
          <Falcon icon="ellipsis-vertical"/>
        </IconButton>}>
      {children}
    </Menu.Root>);
}
